import { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { Button, Container, } from 'reactstrap';
// import { personaPageData } from '../../common';
// import { getIPGeoLocation } from "../../common/GeneralUtils";
// import { ArrowMultiIcon, ArrowRoundedOneIcon, ArrowRoundedTwoIcon, CrossMultiIcon, DoitMultiIcon, DownMultiFillIcon } from "../../common/icons";
// import * as Icons from "../../common/icons/personaPageDataIcons";
// core components
import Header from "../../components/header/header";
import ContactBanner from "../../components/banner/ContactBanner";
import Footer from "../../components/footer/footer";
// import SittingImage from '../../assets/images/sitting-man.png'
// import VectorImage from '../../assets/images/Vector.svg'
// import QuibImage from '../../assets/images/quib.svg'
// import ManPointToTargetImage from '../../assets/images/man-point-to-target.svg'
// import TargetPointImage from '../../assets/images/target-point.svg'
// import ChallengesImage from '../../assets/images/challenges.svg'
// import WhyVarahiSofBtnLineImage from '../../assets/images/why-button-arrow-line.svg'
// import SecondImage from '../../assets/images/second.svg'
import axios from "axios";
import MeetRamSection from "../../components/Persona/MeetRamSection";
import IdentifiersSection from "../../components/Persona/IdentifiersSection";
import GoalsSection from "../../components/Persona/GoalsSection";
import ChallengesSection from "../../components/Persona/ChallengesSection";
import WhyVarahiSoftSection from "../../components/Persona/WhyVarahiSoftSection";
// import { useLocation } from "react-router-dom";
// import { BranchTreeIcon } from "../../common/icons/branchTreeIcon";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const ContactBanner = Loadable(
//     lazy(() => import('../../components/banner/ContactBanner'))
// )
// const SittingImage = Loadable(
//     lazy(() => import('../../assets/images/sitting-man.png'))
// )
// const VectorImage = Loadable(
//     lazy(() => import('../../assets/images/Vector.svg'))
// )
// const QuibImage = Loadable(
//     lazy(() => import('../../assets/images/quib.svg'))
// )
// const ManPointToTargetImage = Loadable(
//     lazy(() => import('../../assets/images/man-point-to-target.svg'))
// )
// const TargetPointImage = Loadable(
//     lazy(() => import('../../assets/images/target-point.svg'))
// )
// const ChallengesImage = Loadable(
//     lazy(() => import('../../assets/images/challenges.svg'))
// )
// const WhyVarahiSofBtnLineImage = Loadable(
//     lazy(() => import('../../assets/images/why-button-arrow-line.svg'))
// )
// const SecondImage = Loadable(
//     lazy(() => import('../../assets/images/second.svg'))
// )


const PersonaScreen = () => {
    // const location = useLocation();
    const [personaPageData, setData] = useState({});
    // const [geoLocationData, setGeoLocationData] = useState(null);

    const getAllPersonaPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/personaPageData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        // getIPGeoLocation(location.pathname)
        getAllPersonaPageData()
    }, [])

    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper blogs_details">
                <div className="container-fluid">
                    <div className="project-page">
                        <ContactBanner
                            bannerImg={personaPageData?.bannerImg}
                            data={personaPageData?.bannerData}
                        />
                    </div>
                    <MeetRamSection />
                    <IdentifiersSection demographics={personaPageData?.demographics} identifiers={personaPageData?.identifiers} />
                    <GoalsSection goalsData={personaPageData?.goalsData} />
                    <ChallengesSection challenges={personaPageData?.challenges} />
                    <WhyVarahiSoftSection WhyVarahiSoft={personaPageData?.WhyVarahiSoft} />
                </div>
            </div>
            <Footer />
        </div>
    );
}

PersonaScreen.propTypes = {
    classes: PropTypes.object
};

export default PersonaScreen;
